import React from 'react';
import { Container, Row } from 'reactstrap';

const Dashboard = () => {
    return (
        <Container>
            <Row>
                <h1>Network Dashboard</h1>
                <p>More information about your network will be presented here.</p>
            </Row>
        </Container>
    );
};

export default Dashboard;
